import Constants from '../constants/Constants'
import { setTimeout } from 'timers'

let url, headers, apikey
let notifsId = -1

const makeHeader = (infosWS) => {
  url = infosWS.url + Constants.UrlsConstants.forms.formBaseUrl
  headers = new Headers({
    'Content-Type': 'application/json',
    'x-api-key': infosWS.apiKey,
    'x-secret-key': infosWS.secretKey,
  })
  return headers
}
const createNotif = (title, message, type) => {
  return {
    id: ++notifsId,
    title,
    message,
    type,
  }
}
export const selectForm = id => {
  return {
    type: Constants.ActionsConstants.FORMS.FORM.SELECT,
    id,
  }
}
export const createForm = (dispatch, name) => {
  fetch(url + '/add', {
    method: 'POST',
    headers,
    body: JSON.stringify({ name, 'fields': [], apikey }),
  })
  .then(r => r.json())
  .then(res => {
    if (res.success === true) {
      let notif = createNotif('Succès', 'La table "' + name + '" a été crée avec succès.', 'success')
      setTimeout(() => {
        dispatch(timeOutNotif(notif))
      }, notif.delay || 2500)
      dispatch({ type: Constants.ActionsConstants.FORMS.FORM.CREATE, newForm: res.data })
      dispatch({type: 'NOTIF_THROWN', notif})
    }
  })
}
export const deleteForm = (dispatch, name) => {
  fetch(url + '/delete', {
    method: 'POST',
    headers,
    body: JSON.stringify({ name, apikey }),
  })
  .then(r => r.json())
  .then(res => {
    if (res.success === true) {
      let notif = createNotif('Succès', 'La table "' + name + '" a été supprimée avec succès.', 'success')
      setTimeout(() => {
        dispatch(timeOutNotif(notif))
      }, notif.delay || 2500)
      loadForm(dispatch, {}, true)
      dispatch({type: 'NOTIF_THROWN', notif})
    }
  })
}
export const resetForms = (dispatch) => {
  dispatch({ type: Constants.ActionsConstants.FORMS.FORM.LOAD, forms: [], isFetching: false })
}
export const loadForm = (dispatch, infosWS={}, deleted = false) => {
  let forms = []
  if (JSON.stringify(infosWS) !== '{}') makeHeader(infosWS)
  return fetch(url + '/find', {
    method: 'POST',
    headers,
  })
  .then(r => r.json())
  .then(res => {
    if (res.success) {
      forms = res.data
      if (deleted === false) {
        dispatch({ type: Constants.ActionsConstants.FORMS.FORM.LOAD, forms, isFetching: false })
      } else {
        dispatch({ type: Constants.ActionsConstants.FORMS.FORM.LOAD, forms, isFetching: false, delete: true })
      }
    } else {
      dispatch({ type: 'FORMS_NOT_FOUND', message: 'problem' })
    }
  })
  .catch((error) => {
    console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message)
    dispatch({type: 'FORMS_NOT_FOUND', message: 'problem' + error.message})
  })
}
export const loadRecord = (dispatch, formName) => {
  dispatch({type: 'FETCH', isFetching: true})
  fetch(url + '/record/find', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      formName,
      'criteria': {},
      apikey,
    }),
  })
  .then(r => r.json())
  .then(res => {
    dispatch({type: Constants.ActionsConstants.FORMS.RECORD.LOAD, formName, records: res.data})
  })
}
/*  Wait for records to be fetched before showing fetched forms ?
export const loadForm = (dispatch, deleted = false) => {
  let forms = []
  let promises = []
  fetch(url + '/find', {
    method: 'POST',
    headers,
  })
  .then(r => r.json())
  .then(res => {
    forms = res.data
    return forms
  })
  .then(forms => {
    forms.forEach(f => {
      promises.push(new Promise((resolve, reject) => {
        f.records = []
        fetch(url + '/record/find', {
          method: 'POST',
          headers,
          body: JSON.stringify({
            'formName': f.name,
            'criteria': {},
            apikey,
          }),
        })
        .then(r => r.json())
        .then(res => {
          f.records = res.data
          resolve()
        })
      }))
    })
  })
  .then(() => {
    Promise
    .all(promises)
    .then(() => {
      if (deleted === false) {
        dispatch({ type: Constants.ActionsConstants.FORMS.FORM.LOAD, forms, isFetching: false })
      } else {
        dispatch({ type: Constants.ActionsConstants.FORMS.FORM.LOAD, forms, isFetching: false, delete: true })
      }
    })
  })
}
*/
export const selectedField = id => {
  return {
    type: Constants.ActionsConstants.FORMS.FIELD.SELECT,
    id,
  }
}
export const multiSelectField = field => {
  return {
    type: Constants.ActionsConstants.FORMS.FIELD.MULTISELECT,
    field,
  }
}
export const createField = (dispatch, data) => {
  fetch(url + '/field/add', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      'formName': data.formName,
      'name': data.name,
      'type': data.type,
      apikey,
      'mandatory': data.mandatory,
      'unique': data.unique,
      'defaultValue': data.defaultValue,
    }),
  })
  .then(r => r.json())
  .then(res => {
    fetch(url + '/record/find', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        'formName': data.formName,
        'criteria': {},
        apikey,
      }),
    })
    .then(r => r.json())
    .then(rec => {
      if (rec.success === true) {
        let notif = createNotif('Succès', 'Champ crée  avec succès.', 'success')
        setTimeout(() => {
          dispatch(timeOutNotif(notif))
        }, notif.delay || 1500)
        dispatch({type: Constants.ActionsConstants.FORMS.FORM.UPDATE, form: res.data, records: rec.data})
        dispatch({type: 'NOTIF_THROWN', notif})
      }
    })
  })
}
export const deleteField = (dispatch, data) => {
  fetch(url + '/field/remove', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      'formName': data.formName,
      'name': data.name,
      apikey,
    }),
  })
  .then(r => r.json())
  .then(res => {
    fetch(url + '/record/find', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        'formName': data.formName,
        'criteria': {},
        apikey,
      }),
    })
    .then(r => r.json())
    .then(rec => {
      if (rec.success === true) {
        let notif = createNotif('Succès', 'Champ supprimé avec succès.', 'success')
        setTimeout(() => {
          dispatch(timeOutNotif(notif))
        }, notif.delay || 1500)
        dispatch({type: Constants.ActionsConstants.FORMS.FORM.UPDATE, form: res.data, records: rec.data})
        dispatch({type: 'NOTIF_THROWN', notif})
      }
    })
  })
}
export const editField = (dispatch, data) => {
  if (data.hasOwnProperty('cancel')) {
    return {
      type: Constants.ActionsConstants.FORMS.FORM.UPDATE,
      cancel: true,
    }
  }
  fetch(url + '/field/update', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      'formName': data.formName,
      'oldName': data.oldName,
      'newName': data.newName,
      'type': data.type,
      apikey,
      'mandatory': data.mandatory,
      'unique': data.unique,
      'defaultValue': data.defaultValue,
    }),
  })
  .then(r => r.json())
  .then(res => {
    fetch(url + '/record/find', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        'formName': data.formName,
        'criteria': {},
        apikey,
      }),
    })
    .then(r => r.json())
    .then(rec => {
      if (rec.success === true) {
        let notif = createNotif('Succès', 'Champs mis à jour avec succès.', 'success')
        setTimeout(() => {
          dispatch(timeOutNotif(notif))
        }, notif.delay || 1500)
        dispatch({type: Constants.ActionsConstants.FORMS.FORM.UPDATE, form: res.data, records: rec.data})
        dispatch({type: 'NOTIF_THROWN', notif})
      }
    })
  })
}
export const selectRecord = id => {
  return {
    type: Constants.ActionsConstants.FORMS.RECORD.SELECT,
    id,
  }
}
export const createRecord = (dispatch, data) => {
  fetch(url + '/record/add', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      formName: data.formName,
      fields: data.fields,
      apikey,
    }),
  })
  .then(r => r.json())
  .then(res => {
    if (res.success === true) {
      let notif = createNotif('Succès', 'Données enregistrées avec succès.', 'success')
      setTimeout(() => {
        dispatch(timeOutNotif(notif))
      }, notif.delay || 3000)
      dispatch({type: Constants.ActionsConstants.FORMS.RECORD.CREATE, record: res.data})
      dispatch({type: 'NOTIF_THROWN', notif})
    } else {
      console.log('error')
    }
  })
}
export const deleteRecord = (dispatch, data) => {
  fetch(url + '/record/delete', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      formName: data.formName,
      criteria: { id: data.criteria },
      apikey,
    }),
  })
  .then(r => r.json())
  .then(res => {
    if (res.success === true) {
      let notif = createNotif('Succès', 'Données supprimées avec succès.', 'success')
      setTimeout(() => {
        dispatch(timeOutNotif(notif))
      }, notif.delay || 1500)
      dispatch({type: Constants.ActionsConstants.FORMS.RECORD.DELETE, id: data.criteria})
      dispatch({type: 'NOTIF_THROWN', notif})
    }
  })
}
export const editRecord = (dispatch, data) => {
  if (data.hasOwnProperty('cancel')) {
    return {
      type: Constants.ActionsConstants.FORMS.RECORD.UPDATE,
      cancel: true,
    }
  }
  let recordToUpdate = data.record.id
  fetch(url + '/record/update', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      formName: data.formName,
      data: data.record,
      criteria: { id: recordToUpdate },
      apikey,
    }),
  })
  .then(r => r.json())
  .then(res => {
    if (res.success === true) {
      let notif = createNotif('Succès', 'Données mises à jour avec succès.', 'success')
      setTimeout(() => {
        dispatch(timeOutNotif(notif))
      }, notif.delay || 1500)
      dispatch({type: Constants.ActionsConstants.FORMS.RECORD.UPDATE, id: recordToUpdate, record: res.data})
      dispatch({type: 'NOTIF_THROWN', notif})
    }
  })
}
export const sortRecord = (selectedPage, criteria) => {
  return {
    type: Constants.ActionsConstants.FORMS.RECORD.SORT,
    selectedPage,
    criteria,
  }
}
export const filterRecord = (criteriaFilter, searchTerm) => {
  return {
    type: Constants.ActionsConstants.FORMS.RECORD.FILTER,
    criteriaFilter,
    searchTerm,
  }
}
export const throwNotif = (dispatch, notif) => {
  notif.id = notifsId++
  setTimeout(() => {
    dispatch(timeOutNotif(notif))
  }, notif.delay || 5000)
  return {
    type: 'NOTIF_THROWN',
    notif,
  }
}
export const timeOutNotif = notif => {
  return {
    type: 'NOTIF_TIMEDOUT',
    notif,
  }
}
export const throwWarning = (data) => {
  return {
    type: 'WARN',
    data,
  }
}
export const changeForm = (dispatch, data) => {
  loadRecord(dispatch, data.formName)
  return {
    type: 'CHANGE_FORM',
    data,
  }
}
const getSlicedArray = (originalArray, limit = 300) => {
  let arraySliced = [[]]
  for (let i=0; i < originalArray.length; i++) {
    if (i !== 0 && i%limit === 0) {
      arraySliced.push([])
    }
    arraySliced[arraySliced.length-1].push(originalArray[i])
  }
  return arraySliced
}
export const formsWS = (state = { forms: [],
  selectedForm: {},
  selectedPage: 0,
  selectedField: {},
  selectedRecord: {},
  selectedFields: [],
  selectedRecords: [],
  displayMode: '',
  filteredRecords: [],
  notifs: [],
  isFetching: true,
  message: '',
  func: null,
  component: '',
  criteriaFilter: 'all',
  warnTitle: '',
  error: '',
},
  action = {}) => {
  switch (action.type) {
    case 'WARN':
      return Object.assign({}, state, {
        warnTitle: action.data.warnTitle,
        message: action.data.message,
        func: action.data.func,
        component: action.data.component,
      })

    case 'FETCH':
      return Object.assign({}, state, { isFetching: action.isFetching })

    case Constants.ActionsConstants.FORMS.FORM.UPDATE:
      if (action.cancel) return Object.assign({}, state, { selectedField: {}, component: null, message: '' })
      let updatedForms = [...state.forms]
      let formToUpdate = updatedForms.findIndex(form => form.id === action.form.id)
      updatedForms[formToUpdate] = action.form
      action.records !== null
      ? updatedForms[formToUpdate].records = getSlicedArray(action.records)
      : updatedForms[formToUpdate].records = state.selectedForm.records
      return Object.assign({}, state, {
        forms: updatedForms,
        selectedForm: updatedForms[formToUpdate],
        filteredRecords: updatedForms[formToUpdate].records,
        selectedField: {},
        selectedFields: [],
        message: '',
        action: null,
        component: null,
      })

    case Constants.ActionsConstants.FORMS.FORM.LOAD:
      let newState = Object.assign({}, state)
      newState.forms = action.forms
      newState.isFetching = false
      newState.selectedForm = {}
      newState.message = ''
      newState.error = ''
      newState.func = null
      return newState

    case Constants.ActionsConstants.FORMS.FORM.SELECT:
      if (state.forms.findIndex(e => e.id === action.id) === -1) return state
      let selectedFormIndex = state.forms.findIndex(e => e.id === action.id)
      let formSelected = state.forms[selectedFormIndex]
      if (!formSelected.constraints) {
        formSelected.constraints = {
          parents: [],
          childs: [],
          uniqueness: [],
        }
      }
      return Object.assign({}, state, {
        selectedForm: formSelected,
        displayMode: 'schema',
        filteredRecords: formSelected.records !== undefined ? getSlicedArray(formSelected.records) : [],
        selectedPage: 0,
      })

    case Constants.ActionsConstants.FORMS.FORM.CREATE:
      if (!action.newForm.name || state.forms.findIndex(e => e.name === action.newForm.name) !== -1) return state
      return Object.assign({}, state, {
        forms: [...state.forms, action.newForm],
        selectedForm: action.newForm,
        message: '',
        action: null,
        component: null,
      })

    case Constants.ActionsConstants.FORMS.FIELD.SELECT:
      return Object.assign({}, state, { selectedField: state.selectedForm.fields[action.id] })

    case Constants.ActionsConstants.FORMS.FIELD.MULTISELECT:
      let updatedSelectedFields
      let fieldAlreadySelected = state.selectedFields.findIndex(field => field === action.field._name)
      fieldAlreadySelected === -1
      ? updatedSelectedFields = [...state.selectedFields, action.field._name]
      : updatedSelectedFields = [...state.selectedFields.slice(0, fieldAlreadySelected),
                                 ...state.selectedFields.slice(fieldAlreadySelected + 1),
                                ]
      return Object.assign({}, state, {selectedFields: updatedSelectedFields})

    case Constants.ActionsConstants.FORMS.RECORD.CREATE:
      let updatedForm = Object.assign({}, state.selectedForm)
      updatedForm.records = [...state.selectedForm.records, action.record]
      let updatedRecordForms = [...state.forms]
      updatedRecordForms[updatedRecordForms.findIndex(form => form.name === updatedForm.name)] = updatedForm
      return Object.assign({}, state, {
        forms: updatedRecordForms,
        selectedForm: updatedForm,
        filteredRecords: getSlicedArray(updatedForm.records),
      })

    case Constants.ActionsConstants.FORMS.RECORD.LOAD:
      let formToLoad = Object.assign({}, state.selectedForm)
      formToLoad.records = action.records
      let formsToLoad = [...state.forms]
      let iToUpdate = formsToLoad.findIndex(form => form.id === formToLoad.id)
      formsToLoad[iToUpdate] = formToLoad
      return Object.assign({}, state, {
        selectedForm: formToLoad,
        forms: formsToLoad,
        isFetching: false,
        filteredRecords: getSlicedArray(action.records),
      })

    case Constants.ActionsConstants.FORMS.RECORD.SELECT:
      return Object.assign({}, state, { selectedRecord: state.selectedForm.records[action.id] })

    case Constants.ActionsConstants.FORMS.RECORD.DELETE:
      let deleteRecordForm = Object.assign({}, state.selectedForm)
      let recordToDelete = deleteRecordForm.records.findIndex(record => record.id === action.id)
      deleteRecordForm.records = [...state.selectedForm.records.slice(0, recordToDelete),
                                  ...state.selectedForm.records.slice(recordToDelete + 1),
                                 ]
      let deletedRecordForms = [...state.forms]
      deletedRecordForms[deletedRecordForms.findIndex(form => form.name === deleteRecordForm.name)] = deleteRecordForm
      return Object.assign({}, state, {
        forms: deletedRecordForms,
        selectedForm: deleteRecordForm,
        filteredRecords: getSlicedArray(deleteRecordForm.records),
      })

    case Constants.ActionsConstants.FORMS.RECORD.UPDATE:
      if (action.cancel && action.cancel === true) {
        return Object.assign({}, state, { selectedRecord: {}, component: null, message: '' })
      }
      let editedRecordForm = Object.assign({}, state.selectedForm)
      let indexToUpdate = editedRecordForm.records.findIndex(r => r.id === action.id)
      editedRecordForm.records[indexToUpdate] = action.record.find(r => r.id === action.id)
      let editedRecordForms = [...state.forms]
      editedRecordForms[editedRecordForms.findIndex(form => form.name === editedRecordForm.name)] = editedRecordForm
      return Object.assign({}, state, {
        forms: editedRecordForms,
        selectedForm: editedRecordForm,
        selectedRecord: {},
        filteredRecords: getSlicedArray(editedRecordForm.records),
        message: '',
        action: null,
        component: null,
      })

    case Constants.ActionsConstants.FORMS.RECORD.SORT:
      let recordsToSort = [...state.filteredRecords]
      recordsToSort[action.selectedPage].sort((a, b) => {
        if (typeof a[action.criteria] !== 'number') {
          return String(a[action.criteria]).toLowerCase().localeCompare(String(b[action.criteria]).toLowerCase())
        } else {
          if (a[action.criteria] < b[action.criteria]) return -1
          if (a[action.criteria] > b[action.criteria]) return 1
          return 0
        }
      })
      if (recordsToSort[action.selectedPage].every((e, i) => {
        return e === [...state.filteredRecords][action.selectedPage][i]
      })) {
        recordsToSort[action.selectedPage].sort((b, a) => {
          if (typeof a[action.criteria] !== 'number') {
            return String(a[action.criteria]).toLowerCase().localeCompare(String(b[action.criteria]).toLowerCase())
          } else {
            if (a[action.criteria] < b[action.criteria]) return -1
            if (a[action.criteria] > b[action.criteria]) return 1
            return 0
          }
        })
      }
      return Object.assign({}, state, { filteredRecords: recordsToSort })

    case Constants.ActionsConstants.FORMS.RECORD.FILTER:
      if (!action.searchTerm.trim()) {
        return Object.assign({}, state, { filteredRecords: getSlicedArray(state.selectedForm.records) })
      }
      let filteredRecords = []
      if (action.criteriaFilter === 'all') {
        state.selectedForm.records.forEach(record => {
          for (let prop in record) {
            if (typeof record[prop] !== 'undefined') {
              if (typeof record[prop] === 'object') {
                if (JSON.stringify(record[prop]).toLowerCase().includes(action.searchTerm.trim().toLowerCase())) {
                  filteredRecords.push(record)
                  break
                }
              } else {
                if (record[prop].toString().toLowerCase().includes(action.searchTerm.trim().toLowerCase())) {
                  filteredRecords.push(record)
                  break
                }
              }
            }
          }
        })
      } else {
        state.selectedForm.records.forEach(record => {
          for (let prop in record) {
            if (typeof record[prop] !== 'object' &&
                typeof record[prop] !== 'undefined' &&
                prop === action.criteriaFilter) {
              if (record[prop].toString().toLowerCase().includes(action.searchTerm.trim().toLowerCase())) {
                filteredRecords.push(record)
                break
              }
            }
          }
        })
      }
      let filteredRecordsSliced = getSlicedArray(filteredRecords)
      return Object.assign({}, state, { filteredRecords: filteredRecordsSliced })

    case 'NOTIF_THROWN':
      action.notif['id'] = state.notifs.length
      let notifs = [...state.notifs, action.notif]
      return Object.assign({}, state, { notifs })

    case 'NOTIF_TIMEDOUT':
      let notifToDelete = [...state.notifs].findIndex(notif => notif.id === action.notif.id)
      let deletedNotifs = [...state.notifs.slice(0, notifToDelete),
                           ...state.notifs.slice(notifToDelete + 1),
                          ]
      return Object.assign({}, state, {notifs: deletedNotifs})
    case 'CHANGE_FORM' :
      let newSelectedForm = state.forms.find(f => f.name === action.data.formName)
      return Object.assign({}, state, {selectedForm: newSelectedForm}) // 'displayMode':'data'
    case 'FORMS_NOT_FOUND':
      return Object.assign({}, state, {error: action.message})
    default:
      return state
  }
}
